import * as tslib_1 from "tslib";
import { HttpClient } from '@angular/common/http';
import { AppStateFacade } from '@app-state';
import { ODataService } from '@services/generics/odata.service';
import { MapperService } from '@services/mapper.service';
import { map } from 'rxjs/operators';
var NAMESPACE = 'UiPath.Server.Configuration.OData';
var QueueItemCommentService = /** @class */ (function (_super) {
    tslib_1.__extends(QueueItemCommentService, _super);
    function QueueItemCommentService(http, _a) {
        var authConfig = _a.authConfig;
        var _this = _super.call(this, http, MapperService.queueItemCommentMap) || this;
        _this._endpoint = authConfig.odataBaseUrl + "/QueueItemComments";
        return _this;
    }
    QueueItemCommentService.prototype.getByItem = function (queueItemId) {
        var _this = this;
        return this._http.get(this._endpoint + "/" + NAMESPACE + ".GetQueueItemCommentsHistory(queueItemId=" + queueItemId + ")?$orderby=CreationTime desc")
            .pipe(map(function (response) { return _this._mapData(response); }));
    };
    return QueueItemCommentService;
}(ODataService));
export { QueueItemCommentService };
